import { PropsWithChildren, useEffect } from 'react';
import {
  PushNotifications,
  RegistrationError,
} from '@capacitor/push-notifications';
import useAuthContext from 'src/context/AuthProvider/useAuthContext';
import AuthRepository from 'src/features/auth/data/AuthRepository';
import { diContainer } from 'src/inversify.config';
import { Capacitor } from '@capacitor/core';
import { useNavigate } from 'react-router-dom';

const authRepository = diContainer.get<AuthRepository>(AuthRepository);

export default function PushNotificationsContainer({
  children,
}: PropsWithChildren) {
  const { session } = useAuthContext();
  const navigate = useNavigate();

  useEffect(() => {
    const platform = Capacitor.getPlatform();
    if (session && platform !== 'web') {
      PushNotifications.checkPermissions().then((res) => {
        if (res.receive !== 'granted') {
          PushNotifications.requestPermissions().then((res) => {
            if (res.receive === 'denied') {
              console.log('Push Notification permission denied');
            } else {
              console.log('Push Notification permission granted');
              register();
            }
          });
        } else {
          register();
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [session]);

  const register = () => {
    // Register with Apple / Google to receive push via APNS/FCM
    PushNotifications.register();

    // On success, we should be able to receive notifications
    PushNotifications.addListener('registration', (token) => {
      authRepository.registerDeviceId({ device_id: token.value });
    });

    // Some issue with our setup and push will not work
    PushNotifications.addListener(
      'registrationError',
      (error: RegistrationError) => {
        alert('Error on registration: ' + JSON.stringify(error));
      }
    );

    // Handle notification interaction (when user clicks on the notification)
    PushNotifications.addListener(
      'pushNotificationActionPerformed',
      ({ notification }) => {
        const url = notification.data?.url;
        if (url) {
          navigate(url);
        }
      }
    );
  };

  return children;
}
